/* eslint-disable */
<template>
  <div id="loader">  
    <v-progress-circular color="white" indeterminate size=70 :width="5">
      <!--<img src="//cdn.playposit.com/images/dog_white.png" alt="avatar" width="50px">-->
    </v-progress-circular>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'loader',
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
    ])
  },
  methods:{
  ...mapActions([
  ]),
  },
  watch: {
  },
  mounted() {
  }
};
</script>

<style scoped>
#loader {
  width:100vw;
  height: 100vh;
  background-color: #212121;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}
</style>
